<template>
  <div class="AirConditioningPanelWrap">
    <h6>{{ activeItem.name }}</h6>
    <div class="temRow">
      <p>
        当前 <span>{{ activeItem.temp }}</span
        >℃
      </p>
      <el-switch
        v-model="activeItem.RunSign"
        :active-value="1"
        :inactive-value="0"
        @change="switchBtn"
        :disabled="!controlPermissions"
      >
      </el-switch>
    </div>
    <div class="modelRow">
      <el-radio
        v-model="activeItem.Status"
        :label="0"
        border
        size="mini"
        @change="changeStatus"
        :disabled="!controlPermissions"
      >
        制冷</el-radio
      >
      <el-radio
        v-model="activeItem.Status"
        :label="1"
        border
        size="mini"
        @change="changeStatus"
        :disabled="!controlPermissions"
        >制热</el-radio
      >
      <el-radio
        v-model="activeItem.Status"
        :label="2"
        border
        size="mini"
        @change="changeStatus"
        :disabled="!controlPermissions"
        >送风</el-radio
      >
    </div>

    <div class="setWrap">
      <p>温度</p>
      <div class="editWrap">
        <i
          v-if="controlPermissions"
          class="el-icon-minus btn"
          @click="changeTem('')"
        ></i>
        <h6>{{ activeItem.SetTemperature }} <span>℃</span></h6>
        <i
          v-if="controlPermissions"
          class="el-icon-plus btn"
          @click="changeTem('add')"
        ></i>
      </div>
    </div>
    <div class="setWrap">
      <p>风速</p>
      <div class="editWrap">
        <i
          v-if="controlPermissions"
          class="el-icon-minus btn"
          @click="changeWind('')"
        ></i>
        <h6>{{ activeItem.SetAirVolume }} <span>%</span></h6>
        <i
          v-if="controlPermissions"
          class="el-icon-plus btn"
          @click="changeWind('add')"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { judgeAuthority } from "@/assets/js/utils";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      timer: null,
      timer1: null,
      controlPermissions: false,
    };
  },
  methods: {
    switchBtn() {
      this.$emit("handeleData", {
        entityId: this.activeItem.id,
        isOpen: this.activeItem.RunSign == 1 ? "ON" : "OFF",
        key: "RunSign",
        type: this.activeItem.deviceType,
      });
    },
    changeStatus(val) {
      this.$emit("handeleData", {
        entityId: this.activeItem.id,
        isOpen: "CHANGE",
        key: "Status",
        type: this.activeItem.deviceType,
        value: val,
      });
    },
    changeTem(type) {
      if (type == "add") {
        if (this.activeItem.SetTemperature >= 35) {
          this.$message.error("温度设置已达上限!");
          return;
        }
        this.activeItem.SetTemperature += 1;
      } else {
        if (this.activeItem.SetTemperature <= 16) {
          this.$message.error("温度设置已达下限!");
          return;
        }
        this.activeItem.SetTemperature -= 1;
      }
      clearTimeout(this.timer);
      this.timer = null;
      this.timer = setTimeout(() => {
        this.$emit("handeleData", {
          entityId: this.activeItem.id,
          isOpen: "CHANGE",
          key: "SetTemperature",
          type: this.activeItem.deviceType,
          value: this.activeItem.SetTemperature,
        });
      }, 1000);
    },
    changeWind(type) {
      if (type == "add") {
        if (this.activeItem.SetAirVolume >= 100) {
          this.$message.error("风量设置已达上限!");
          return;
        }
        this.activeItem.SetAirVolume += 10;
      } else {
        if (this.activeItem.SetAirVolume <= 10) {
          this.$message.error("风量设置已达下限!");
          return;
        }
        this.activeItem.SetAirVolume -= 10;
      }
      clearTimeout(this.timer1);
      this.timer1 = null;
      this.timer1 = setTimeout(() => {
        this.$emit("handeleData", {
          entityId: this.activeItem.id,
          isOpen: "CHANGE",
          key: "SetAirVolume",
          type: this.activeItem.deviceType,
          value: this.activeItem.SetAirVolume,
        });
      }, 1000);
    },
  },
  created() {
    this.controlPermissions = judgeAuthority("zixitong:kongtiao:controls:edit");
  },
};
</script>

<style lang="scss" scoped>
.AirConditioningPanelWrap {
  width: 90%;
  height: 100%;
  margin: 0 auto;
  // background: saddlebrown;
  ::v-deep .el-radio {
    margin-right: 0;
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      padding: 0 7px 0 9px;
      text-align: center;
    }
  }
  .temRow {
    margin: 15px 0;
    @include setFlexBetween;
    p {
      span {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .modelRow {
    @include setFlexAround;
    margin-bottom: 15px;
  }
  .setWrap {
    @include setFlexBetween;
    margin: 15px 0;
    .editWrap {
      width: 75%;
      @include setFlexAround;
      i {
        font-size: 20px;
      }
      h6 {
        font-size: 16px;
        width: 30%;
        text-align: center;
        span {
          font-size: 14px;
        }
      }
      .btn {
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: #28cccb;
        }
      }
    }
  }
}
</style>
